import { Button, Card, Col, message, Row, Upload, Table } from "antd";

import React, { useState } from "react";

import PageHeading from "../../../../../components/common/PageHeading";
import { data } from './smartBillEntryData'

import "./smartBillEntry.css";

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: "Vendor",
    dataIndex: "vendor",
    sorter: (a, b) => a.vendor.length - b.vendor.length,
  },
  {
    title: "Property",
    dataIndex: "property",
    sorter: (a, b) => a.property.length - b.property.length,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    sorter: (a, b) => a.amount.length - b.amount.length,
  },
  {
    title: "Ref.#",
    dataIndex: "ref",
    sorter: (a, b) => a.ref.length - b.ref.length,
  },
  {
    title: "Uploaded By",
    dataIndex: "uploadedBy",
    sorter: (a, b) => a.uploadedBy.length - b.uploadedBy.length,
  },
  {
    title: "Status",
    key: "status",
    fixed: "right",
    render: (_,render) => <a href={`/accounting/payables_bills/smartbillentry/${render.key}`}>Ready to review</a>,
    sorter: (a, b) => a.name.length - b.name.length,
  },
];

const SmartBillEntry = () => {
  const [uploadInvoices, setUploadInvoices] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const hasSelected = selectedRowKeys.length > 0;

  const { Dragger } = Upload;
  const props = {
    name: "file",
    multiple: true,
    onChange(info) {
      const { status } = info.file;
      setUploadInvoices(info.file);
      if (uploadInvoices !== "uploading") {
        console.log(uploadInvoices);
      }
      if (uploadInvoices === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (uploadInvoices === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
      setUploadInvoices(null);
    },
  };
  return (
    <div>
      <PageHeading heading="Smart Bill Entry" />
      <Card title="Upload Invoices">
        <p>Instructions For Uploading</p>
        <br />
        <p>
          Choose one or more PDF invoices to upload and process. The status
          column will update for each invoice as they are ready to review. As
          you upload and review more files, the system will better predict
          values to save you time.
        </p>
        <br />
        <p>
          You or your vendors may also upload invoices directly to this page
          using this email: integrityoklahoma@invoices.appfolio.com
        </p>
        <br />
        <Dragger {...props} style={{ padding: "10px" }}>
          <Row gutter={16} justify="center">
            <Col>
              <p className="ant-upload-text">Drag Files Here</p>
            </Col>
            <Col>or</Col>
            <Col>
              <Button>Choose File to Add</Button>
            </Col>
          </Row>
        </Dragger>
        <br />
        <Button type="primary" disabled={uploadInvoices ? false : true}>
          Process Invoices
        </Button>
      </Card>
      <br />
      <Card title="Invoices">
        <div className="bulkActions">
          <span className="bulkActionBtn">Bulk Actions</span>
          <Button type="link" danger disabled={hasSelected ? false : true}>
            Delete
          </Button>
        </div>
        <br />
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={data}
        />
      </Card>
    </div>
  );
};

export default SmartBillEntry;
